module.exports = __webpack_public_path__ + "img/img_09.71bcc6c4.png";